import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { fetchJson } from '@atlassian/jira-fetch';
import { PACKAGE_NAME } from '@atlassian/jira-servicedesk-getting-started-panel-common';
import type { CloudId } from '@atlassian/jira-shared-types';
import { TaskId, type GspState } from '@atlassian/jsm-getting-started-panel';
import type { UserCentricResponse } from '../../types';

export async function handleUserCentricMode(data: GspState, cloudId: CloudId) {
	const mutatedData: GspState = { ...data };

	// we need to unset user centric items if they are set in the ops team page for that user
	mutatedData.completedItems = mutatedData.completedItems.filter((item) => {
		if (item === TaskId.ReviewOnCallSetup || item === TaskId.AddIntegration) {
			return false;
		}
		return true;
	});
	try {
		const userCentricResponse: UserCentricResponse = await fetchJson(
			`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel`,
			{
				method: 'GET',
				mode: 'cors',
			},
		);
		// we will override completed items by getting/setting user-centric endpoint
		const userCentricCompletedItems = userCentricResponse.completedItems.filter((item) => {
			if (item === TaskId.ReviewOnCallSetup || item === TaskId.AddIntegration) {
				return true;
			}
			return false;
		});

		mutatedData.completedItems = [...mutatedData.completedItems, ...userCentricCompletedItems];
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// The list is not initialized yet
		if (error.statusCode !== 404) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'handleUserCentricMode-UserCentricResponse',
					packageName: PACKAGE_NAME,
					// eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
					teamName: 'Alexstrasza',
				},
				sendToPrivacyUnsafeSplunk: true,
			});

			throw error;
		}
	}

	return mutatedData;
}
